import React from 'react';
import {useTranslation} from 'react-i18next';
import {Card, CardBody} from 'reactstrap';
import {mapWithIndex} from '@/util';
import styles from '@/views/Layout/b2b/index.module.css';

const SortableLabel = ({shortCode}) => (
  <span className='badge badge-secondary' style={{backgroundColor: '#005a95'}}>
    {shortCode}
  </span>
);

const SortableList = () => {
  const {t: tr} = useTranslation('nb');
  const items = [
    {columnName: tr('insurance_plan'), shortCode: 'P'},
    {columnName: tr('investment_link'), shortCode: 'L'},
    {columnName: tr('fund_platform'), shortCode: 'F'},
    {columnName: tr('transfer_in'), shortCode: 'T'},
    {columnName: tr('private_bank'), shortCode: 'PB'},
    {columnName: tr('trust'), shortCode: 'TU'},
  ];

  const itemList = mapWithIndex((item, idx) => (
    <li key={idx}>
      <SortableLabel shortCode={item.shortCode} /> {item.columnName}
    </li>
  ))(items);

  return (
    <Card className='mb-4'>
      <CardBody className={styles.sortable_list_box_body}>
        <ul>{itemList}</ul>
      </CardBody>
    </Card>
  );
};

export default SortableList;
export {SortableLabel};
